import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import * as R from 'ramda'

import MenuItem from 'material-ui/MenuItem';

import Combobox from 'components/Combobox'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from 'selectors/common'
import { merchants, properties } from 'selectors/entities'

import { sortSev } from 'utils/stuff'

let select = dirtyRead(
	(state, props) => ({
		party: doc(state, props.objectID)
	  , parties: merchants(state)
	  , properties: properties(state)
	})
)

export class VendorCombobox extends Component{
	render(){
		let { props } = this
		let party = props.party || {}
		return(
			<Combobox
				icon={
					<img
						src={"/manager/static/img/vendor-green.png"}
						style={{
						  width: "20px"
						  , position: "relative"
						  , top: "-2px"
						  , left:"-5px"
						}}
					/>
				}
				unable = {true}
				link={`/manager/${party.type == "merchant"?"vendor":party.type}/${party._id}/`}
				text={party?party.firstName:""}
				defaultValue={party.firstName || ""}
				hintText={<span>Company name</span>}
				dataSource={
					R.map(party => ({
						text: party.accountNumber
						? `${party.firstName || party.fullName} (acct# ${party.accountNumber})`
						: `${party.firstName || ''}`
					  , value: (
							<MenuItem
							  key={party._id}
							  primaryText={
								  <div key = {`${party._id}-card`}>
									  <div>Copy from {(party.fullName)?party.fullName:party.firstName}</div>
									  <div style={{fontSize: "13px", marginTop: "-24px"}}>{party.subtype ? party.subtype:party.type}, account# {(party.accountNumber)?party.accountNumber:"none"}</div>
									  <div style={{fontSize: "13px", marginTop: "-24px", display: (party.propertyID && this.props.properties[party.propertyID]) ? "" : "none"}}>{(party.propertyID && this.props.properties[party.propertyID])? this.props.properties[party.propertyID].alias: ''}</div>
								  </div>
							  }
							/>
						)
					  , id: party._id
				  }), sortSev(props.parties, "firstName"))
				}
				 onChange={(party)=>{
 					let partyObj = party && props.parties[party.id]
 					if (partyObj){
 						props.STAGE({
 							_id: props.objectID
 						  , firstName: party && ((partyObj.fullName)?partyObj.fullName:partyObj.firstName)
 						  , subtype: partyObj.subtype
 						  , address: partyObj.address
 						  , contactName: partyObj.contactName
 						  , phoneNumber: partyObj.phoneNumber
 						  , email: partyObj.email
 						  , web: partyObj.web
 						})
 					}else {
 						props.STAGE({
 							_id: props.objectID
 						  , firstName: party && ((partyObj.fullName)?partyObj.fullName:partyObj.firstName)
 						})
 					}
 				}}
				onBlur={(party)=>{
					props.STAGE({
						_id: props.objectID
					  , firstName: party.target.value
					})
				}}
			/>
		)
	}
}

export default connect(select, dataActions)(VendorCombobox)



// WEBPACK FOOTER //
// ./src/routes/manager/vendorForm/VendorCombobox.js